<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { Button } from '@pkg/sanity-utils/types/button';
import type { ModularBlock } from '@pkg/sanity-utils/types/modularContentBlocks';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string,
    anchorId?: string;
    slides?: Array<{ content: Array<ModularBlock> }>,
    buttons: Array<Button>,
    reverse: boolean,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  slides: props.block?.slides,
  buttons: props.block?.buttons,
  reverse: props.block?.reverse,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data" />
</template>
